<template>
    <div>
        <login-dialog v-if="loginDailogShow" @hide="loginDailogClick"/>
        <div class="top" :style="{'height':tabIndex==0?'74px':'32px'}">
            <div class="topSub">
                <div class="topLLP">
                    <div :class="tabIndex==0?'topLLItem topLLItemSel':'topLLItem'" @click="tabClick(0)">
                        <span>共享话术</span>
                        <div v-if="tabIndex==0"></div>
                    </div>
                    <div class="topLLItemLine"></div>
                    <div :class="tabIndex==1?'topLLItem topLLItemSel':'topLLItem'" class="topLLItem" @click="tabClick(1)">
                        <span>文案库</span>
                        <div v-if="tabIndex==1"></div>
                    </div>
                </div>
                <div class="topRP">
                    <div v-if="tabIndex==0&&huashuTeamList.length" class="topL">
                        <img v-if="huashuTeamList[teamSelIdx].roleId==2" class="topLL" src="https://imagessl.edujia.com/A-1ed71af7_20230804094647.png">
                        <div class="topLR">{{huashuTeamList[teamSelIdx].showName}}</div>
                    </div>
                    <div v-else-if="tabIndex==1&&themeList.length" class="topL">
                        <div class="topLR">{{themeList[themeSelIdx].title}}</div>
                    </div>
                    <div class="topRP">
                        <div class="topR">
                            <img class="topRL" src="https://imagessl.edujia.com/A-1ed71af7_20230804095245.png">
                            <div v-if="tabIndex==0" class="topRR" @click="changeTeam">切换团队</div>
                            <div v-else-if="tabIndex==1" class="topRR" @click="changeTeam">切换文案包</div>
                        </div>
                        <div class="topLLItemLine"></div>
                        <div class="topRR2">
                            <img v-if="faceIcon&&faceIcon.length" class="header-main-top" :src="faceIcon" @click="loginDailogClick" />
                            <img v-else class="header-main-top" src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tabIndex===0" class="searchArea">
                <div class="searchAreaBar">
                    <img src="https://imagessl.edujia.com/A-1ed71af7_20240219112835.png" />
                    <input v-model="keywords" placeholder="输入关键词搜索" type="text"/>
                </div>
                <div v-if="!isSeaching" class="searchAreaBtn" @click="searchBtnClick">搜索</div>
                <div v-else class="searchAreaBtn searchAreaCancelBtn" @click="searchBtnClick">取消</div>
            </div>
        </div>
        <div v-if="teamListShow" class="teamListCover">
            <div class="teamListP">
                <div v-if="tabIndex==0" class="teamList">
                    <div v-for="(item,idx) in huashuTeamList" :class="idx==teamSelIdx?'teamListItemSel teamListItem':'teamListItem'" @click="teamItemClick(idx)">
                        <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"/>
                        <img v-else-if="item.roleId==2" src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"/>
                        <div>{{item.showName}}</div>
                    </div>
                </div>
                <div v-else-if="tabIndex==1" class="teamList">
                    <div v-for="(item,idx) in themeList" :class="idx==themeSelIdx?'teamListItemSel teamListItem':'teamListItem'" @click="themeItemClick(idx)">
                        <!-- <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"/>
                        <img v-else-if="item.roleId==2" src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"/> -->
                        <div>{{item.title}}</div>
                    </div>
                </div>
            </div>    
            <div class="shouqiBtnP">
                <div class="shouqiBtn" @click="hideTeamList">收起<img src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png" /></div>
            </div>
        </div>
        <div class="content" :style="{'padding-top':tabIndex==0?'125px':'83px'}">
            <multipane class="custom-resizer" layout="vertical" @paneResizeStop="paneresizestop">
                <div v-if="!isSeaching" class="typeList" :style="{'width':typeListWidth+'px','height':contentHeight+'px'}" @scroll="typeOnScroll">
                    <div v-if="tabIndex==0" class="typeList" :style="{'height':contentHeight+'px'}" @scroll="typeOnScroll">
                        <div v-for="(item,idx) in typeList" :class="typeSelIdx==idx?'typeListItemSel typeListItem':'typeListItem'" @click="huashuClick(idx)">
                            <div>{{item.labelName}}</div>
                        </div>
                    </div>
                    <div v-else-if="tabIndex==1" class="typeList" :style="{'height':contentHeight+'px'}" @scroll="typeOnScroll">
                        <div v-for="(item,idx) in themeCategoryList" :class="themeCategorySelIdx==idx?'typeListItemSel typeListItem':'typeListItem'" @click="wenanCategoryClick(idx)">
                            <div>{{item.labelName}}</div>
                        </div>
                    </div>
                </div>
                <multipane-resizer>
                    <div class="sizeBtn">
                        <div></div><div></div>
                    </div>
                </multipane-resizer>
                    <div class="huashuList" ref="huashuList" :style="{'height':contentHeight+'px'}" @scroll="huashuOnScroll" >
                        <div v-if="tabIndex==0">
                            <div v-for="(item,idx) in huashuList" class="huashuListItem" @contextmenu.prevent="showMenu($event,item,idx)">
                                <div v-if="item.title" class="huashuListItemTop">
                                    <img class="huashuListItemTopL" src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png">
                                    <div class="huashuListItemTopM">{{item.title}}</div>
                                    <img v-if="item.imglist&&item.imglist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click="go2ImageList(idx)">
                                    <img v-else-if="item.filelist&&item.filelist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click="go2ImageList(idx)">
                                </div>
                                <div :ref="item.id" class="huashuListItemDetailNoHide">{{item.allText}}</div>
                                <div v-if="item.title">
                                    <div :class="(item.showBtn&&item.showBtn=='shouqi')?'huashuListItemDetailShowmore':'huashuListItemDetail'" :ref="'show'+item.id" @click="itemClick(idx)">{{item.allText}}</div>
                                    <div v-if="item.showBtn=='zhankai'" class="actionBtn" @click.stop="textShowClick(idx)">展开</div>
                                    <div v-else-if="item.showBtn=='shouqi'" class="actionBtn" @click.stop="textShowClick(idx)">收起</div>
                                </div>
                                <div v-else>
                                    <div class="huashuListItemDetail huashuListItemDetailNoTitle" :ref="'show'+item.id" :style="{'text-indent':(item.imglist&&item.imglist.length)||(item.filelist&&item.filelist.length)?'23px':0,'display':(item.showBtn&&item.showBtn=='shouqi')?'block':'-webkit-box'}" @click="itemClick(idx)">
                                        <img v-if="item.imglist&&item.imglist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click.stop="go2ImageList(idx)">
                                        <img v-else-if="item.filelist&&item.filelist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click.stop="go2ImageList(idx)">
                                        {{item.allText}}
                                    </div>
                                    <div v-if="item.showBtn=='zhankai'" class="actionBtn" @click.stop="textShowClick(idx)">展开</div>
                                    <div v-else-if="item.showBtn=='shouqi'" class="actionBtn" @click.stop="textShowClick(idx)">收起</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="tabIndex==1">
                            <div class="huashuListItem">
                                <div v-if="themeList.length&&themeList[themeSelIdx].title" class="huashuListItemTop">
                                    <!-- <img class="huashuListItemTopL" src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"> -->
                                    <!-- <div class="huashuListItemTopM huashuListItemTopMBig">{{themeList[themeSelIdx].title}}</div> -->
                                   <!--  <img v-if="item.imglist&&item.imglist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click="go2ImageList(idx)">
                                    <img v-else-if="item.filelist&&item.filelist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click="go2ImageList(idx)"> -->
                                </div>
                                <!-- <div v-for="(wenan,idx) in wenanList" @contextmenu.prevent="showWenanMenu($event,wenan,idx)"> -->
                                <div v-for="(wenan,idx) in wenanList" class="huashuListItemDetailP">
                                    <div :ref="wenan.libraryId" class="huashuListItemDetailNoHide">{{wenan.text}}</div>
                                    <!-- <div v-if="item.title"> -->
                                        <div :class="(wenan.showBtn&&wenan.showBtn=='shouqi')?'huashuListItemDetailShowmore':'huashuListItemDetail'" :ref="'show'+wenan.libraryId" @click="wenanItemClick(idx)">{{wenan.text}}</div>
                                        <div v-if="wenan.showBtn=='zhankai'" class="actionBtn" @click.stop="textShowClick(idx)">展开</div>
                                        <div v-else-if="wenan.showBtn=='shouqi'" class="actionBtn" @click.stop="textShowClick(idx)">收起</div>
                                    <!-- </div>
                                    <div v-else>
                                        <div class="huashuListItemDetail huashuListItemDetailNoTitle" :ref="'show'+item.id" :style="{'text-indent':(item.imglist&&item.imglist.length)||(item.filelist&&item.filelist.length)?'23px':0,'display':(item.showBtn&&item.showBtn=='shouqi')?'block':'-webkit-box'}" @click="itemClick(idx)">
                                            <img v-if="item.imglist&&item.imglist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click.stop="go2ImageList(idx)">
                                            <img v-else-if="item.filelist&&item.filelist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click.stop="go2ImageList(idx)">
                                            {{item.allText}}
                                        </div>
                                        <div v-if="item.showBtn=='zhankai'" class="actionBtn" @click.stop="textShowClick(idx)">展开</div>
                                        <div v-else-if="item.showBtn=='shouqi'" class="actionBtn" @click.stop="textShowClick(idx)">收起</div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <huashu-item-right-menu v-show="menuShow" ref="chat-item-right-menu" :menuY="menuPos[1]" :menuX="menuPos[0]" :menuData="menuData" @edit="editHuashu" @remove="removeHuashu" @hideMenu="hideMenu"></huashu-item-right-menu>
                    </div>
            </multipane>
        </div>
        <div v-if="tabIndex==0" class="bottomBar">
            <div class="addTypeBtn" @click="addHuashuType">
                <img src="https://imagessl.edujia.com/A-1ed71af7_20230825105123.png"/>
                <div>添加分类</div>
            </div>
            <div class="addHuashuBtn" @click="addHuashu">
                <img src="https://imagessl.edujia.com/A-1ed71af7_20230825105123.png"/>
                <div>添加话术</div>
            </div>
            <div class="importHuashuBtn" @click="importHuashu">
                <img src="https://imagessl.lingtuo.cn/A-1ed71af7_20240320092808.png">
                <div>导入话术</div>
            </div>
            <div class="psLbl">鼠标右键编辑/删除</div>
        </div>
    </div>
</template>

<script>
    import LoginDialog from "./LoginDialog";
    import HuashuItemRightMenu from '@/components/HuashuItemRightMenu'
    import { Multipane, MultipaneResizer } from 'vue-multipane';
    var mammoth = require("mammoth");

    export default {
        name: "Home",
        data(){
            return {
                pageWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                pageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                typeSelIdx:0,
                teamSelIdx:0,
                typeList:[],
                typeListLoadend:false,
                huashuList:[],
                huashuListLoadend:false,
                huashuTeamList:[],
                typePageSize:500,
                typePage:1,
                huashuPageSize:500,
                huashuPage:1,
                speechId:0,//团队id
                labelId:0,//分类id
                huashuDetailId:0,//话术文本id

                defaultThemeList:[],//默认文案包列表
                themeList:[],//文案包列表
                themeSelIdx:0,//当前选中文案包索引
                themeId:0,//当前选中文案包id
                themePage:1,
                themePageSize:500,
                themeCategoryList:[],//当前选中文案包分类列表
                themeCategorySelIdx:0,//当前选中文案包分类索引
                themeCategoryPage:1,
                themeCategoryPageSize:20,
                themeCategoryLoading:false,
                themeCategoryLoadend:false,
                wenanLabelId:0,//文案包分类id
                wenanPage:1,
                wenanPageSize:500,
                wenanloading:false,
                wenanList:[],
                wenanListLoadend:false,
                wenanId:0,//文案id

                teamListShow:false,
                loading:false,
                hushuTypeLoading:false,
                audioList:[],
                eleList:[],
                faceIcon:"",
                // loginDailogShow:false,
                menuPos:[],
                menuShow:false,
                menuData:{},
                tabIndex:0,
                keywords:"",
                searchPage:1,
                searchPageSize:50,
                searchLoadend:false,
                searchLoading:false,
                isSeaching:false,

                typeListWidth:144,
            }
        },
        computed:{
            contentHeight(){
                let height=this.pageHeight-125-40-10;
                if(this.tabIndex==1){
                    height+=32+40;
                }
                return height;
            },
            loginDailogShow(){
                return this.$store.state.loginDailogShow;
            },
        },
        watch:{
            keywords(val){
                if(!val){
                    this.isSeaching=false;
                }
            }
        },
        components:{LoginDialog,HuashuItemRightMenu,Multipane, MultipaneResizer },
        methods:{
            convertFileData(text){
                const regex = /【([^【】]+)】(?:\n\n((?:■[^【]+(?:\n[^【■]+)*)*))/g;
                let matches;
                const result = [];

                while ((matches = regex.exec(text)) !== null) {
                    const category = matches[1].trim();
                    const categoryText = matches[2].trim();

                    // 解析分类中的标题和内容
                    const categoryRegex = /■([^【\n]+)\n([^■]*)/g;
                    let categoryMatches;
                    const categoryData = [];

                    while ((categoryMatches = categoryRegex.exec(categoryText)) !== null) {
                        const title = categoryMatches[1].trim();
                        const content = categoryMatches[2].trim().replace(/\n+/g, '\n');
                        categoryData.push({ title, content });
                    }

                    // 添加分类到结果数组
                    result.push({ type: category, sub: categoryData });
                }
                console.log('convertFileData result:',result)
                return result;
            },
            paneresizestop(e){
                localStorage.setItem('typeListWidth',e.clientWidth)
            },
            async searchBtnClick(){
                this.isSeaching=!this.isSeaching;
                if(this.isSeaching){
                    this.searchPage=1;
                    this.huashuList=[];
                    this.searchLoadend=false;
                    this.searchHuashu();
                }else{
                    this.huashuPage=1;
                    this.huashuList=[];
                    this.keywords='';
                    this.huashuListLoadend=false;
                    this.fetchHuashuList();
                }
            },
            async searchHuashu(){
                this.searchLoading=true;
                let params={
                    page:this.searchPage,
                    pageSize:this.searchPageSize,
                    speechId:this.speechId,
                    keyword:this.keywords,
                }
                console.log("huashuSearch params:",params);
                let resp = await this.$http.huashuSearch(params);
                console.log("huashuSearch resp:",resp);
                if(resp.code==200){
                    if(resp.data.array.length){
                        resp.data.array=resp.data.array.map((val)=>{
                            val.eleList=this.generateEleList(val.speechText);
                            val.imglist=val.eleList.filter((eleListItem)=>{
                                eleListItem.val=eleListItem.val.replace("http://","https://")
                                 return eleListItem.type=='img'||eleListItem.type=='video'
                            })
                            val.filelist=val.eleList.filter((eleListItem)=>{
                                eleListItem.val=eleListItem.val.replace("http://","https://")
                                 return eleListItem.type=='file'||eleListItem.type=='audio'
                            })
                            val.allText=this.getEleListAllText(val.eleList);
                            return val;
                        })
                        this.huashuList.splice(this.huashuList.length,0,...resp.data.array)
                    }
                    if(resp.data.array.length<this.searchPageSize){
                        this.searchLoadend=true;
                    }else{
                        this.searchPage++;
                        // this.searchHuashu();
                    }
                }
                this.searchLoading=false;
            },
            tabClick(idx){
                this.isSeaching=false;
                this.keywords="";
                this.tabIndex=idx;
                this.fetchData();
            },
            importHuashu(){
                this.$router.push({path:'/huashuImport',
                    query:{
                        speechId:this.speechId,
                        labelId:this.labelId,
                        teamName:this.huashuTeamList[this.teamSelIdx].showName
                    }
                })
            },
            addHuashuType(){
                this.$prompt('', '添加分类', {
                  confirmButtonText: '保存',
                  cancelButtonText: '取消',
                  inputPattern: /^.+$/,
                  inputErrorMessage: '分类名称不能为空'
                }).then(async ({ value }) => {
                    let params={
                        speechId:this.speechId,
                        labelName:value
                    }
                    console.log("huashuTypeSave params=",params);
                    let resp = await this.$http.huashuTypeSave(params)
                    if(resp.code==200){
                        console.log("huashuTypeSave resp:",resp);
                        this.typeList.splice(this.typeList.length,0,resp.data.object)
                    }else{
                        this.$message({
                          message: resp.message,
                          type: 'warning'
                        });
                    }
                }).catch(() => {     
                });
            },
            addHuashu(){
                let team=this.huashuTeamList[this.teamSelIdx];
                if(team.roleId==0){
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                    return;
                }

                if(localStorage.getItem("editHuashuData")){
                    localStorage.removeItem("editHuashuData")
                }
                this.$router.push({path:'/huashuEdit',
                    query:{
                        speechId:this.speechId,
                        labelId:this.labelId
                    }
                })
            },
            async removeHuashu(){
                if(this.huashuTeamList[this.teamSelIdx].roleId!=0){
                    this.$confirm('确定删除？', '', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        let params={
                            speechId:this.speechId,
                            labelId:this.labelId,
                            id:this.menuData.id,
                        }
                        console.log("huashuRemove params=",params);
                        let resp = await this.$http.huashuRemove(params)
                        if(resp.code==200){
                            console.log("huashuRemove resp:",resp);
                            this.huashuList.splice(this.menuData.idx,1)
                        }else{
                            this.$message({
                            message: resp.message,
                            type: 'warning'
                            });
                        }
                    }).catch(() => {
                            
                    });
                }else{
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                }
            },
            editHuashu(){
                if(this.huashuTeamList[this.teamSelIdx].roleId!=0){
                    localStorage.setItem("editHuashuData",JSON.stringify(this.menuData))
                    this.$router.push({path:'/huashuEdit',
                        query:{
                            speechId:this.speechId,
                            labelId:this.labelId
                        }
                    })
                }else{
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                }
            },
            hideMenu(){
                this.menuShow=false;
            },
            showMenu(e,item,idx){
                console.log("showMenu e:",e);
                console.log("showMenu item:",item);
                // this.menuPos=[e.target.offsetLeft+e.offsetX,e.y];
                this.menuPos=[e.x-120,e.y+this.$refs.huashuList.scrollTop-70];
                this.menuData=item;
                this.menuData.idx=idx;
                this.menuShow=true;
            },
            showWenanMenu(e,wenan,idx){
                console.log("showWenanMenu e:",e);
                console.log("showWenanMenu wenan:",wenan);
                // this.menuPos=[e.target.offsetLeft+e.offsetX,e.y];
                this.menuPos=[e.x-120,e.y+this.$refs.huashuList.scrollTop-70];
                this.menuData=item;
                this.menuData.idx=idx;
                this.menuShow=true;
            },
            loginDailogClick(){
                this.$store.commit("modifyLoginDailogShow",!this.$store.state.loginDailogShow)
            },
            textShowClick(idx){
                if(this.tabIndex==0){
                    this.huashuList[idx].showBtn=this.huashuList[idx].showBtn=='zhankai'?'shouqi':'zhankai'
                }else if(this.tabIndex==1){
                    this.wenanList[idx].showBtn=this.wenanList[idx].showBtn=='zhankai'?'shouqi':'zhankai'
                }
            },
            typeOnScroll(e){
                if(this.tabIndex==0&&this.hushuTypeLoading||this.tabIndex==1&&this.themeCategoryLoading){
                    return;
                }

                let scrollHeight=e.target.scrollHeight;
                let clientHeight=e.target.clientHeight;
                let scrollTop=e.target.scrollTop;
                if(scrollHeight>clientHeight&&scrollTop>=(scrollHeight-clientHeight-5)){
                    if(this.tabIndex==0&&!this.typeListLoadend){
                        this.fetchHuashuTypeList();
                    }else if(this.tabIndex==1&&!this.themeCategoryLoadend){
                        this.fetchWenanPackageCategoryList();
                    }
                }
            },
            huashuOnScroll(e){
                if(this.tabIndex==0&&(this.loading||this.searchLoading)||this.tabIndex==1&&this.wenanloading){
                    return;
                }

                let scrollHeight=e.target.scrollHeight;
                let clientHeight=e.target.clientHeight;
                let scrollTop=e.target.scrollTop;
                if(scrollHeight>clientHeight&&scrollTop>=(scrollHeight-clientHeight-5)){
                    if(this.tabIndex==0&&!this.isSeaching&&!this.huashuListLoadend){
                        this.fetchHuashuList();
                    }else if(this.tabIndex==0&&this.isSeaching&&!this.searchLoadend){
                        this.searchHuashu();
                    }else if(this.tabIndex==1&&!this.wenanListLoadend){
                        this.fetchWenanList();
                    }
                }
            },
            hideTeamList(){
                this.teamListShow=false;
            },
            teamItemClick(idx){
                this.isSeaching=false;
                this.keywords="";
                this.teamSelIdx=idx;
                this.speechId=this.huashuTeamList[idx].speechId;
                localStorage.setItem("lastSelSpeechId",this.speechId)
                this.typePage=1;
                this.typeSelIdx=0;
                this.typeList=[];
                this.huashuPage=1;
                this.huashuList=[];
                this.typeListLoadend=false;
                this.huashuListLoadend=false;
                this.fetchHuashuTypeList();
                this.teamListShow=false;
            },
            async themeItemClick(idx){

                //切换文案包检查
                let params={
                    themeId:this.themeList[idx].themeId
                }
                console.log("checkChangeWenanPackage params=",params);
                let resp = await this.$http.checkChangeWenanPackage(params)
                if(resp.code==200){
                    this.themeSelIdx=idx;
                    this.themeId=this.themeList[idx].themeId;
                    localStorage.setItem("lastSelThemeId",this.themeId)
                    this.themeCategoryPage=1;
                    this.themeCategorySelIdx=0;
                    this.themeCategoryList=[];
                    this.themeCategoryLoadend=false;
                    this.wenanPage=1;
                    this.wenanList=[];
                    this.wenanListLoadend=false;
                    this.fetchWenanPackageCategoryList();
                    this.teamListShow=false;
                }else if(resp.code==0){
                    this.$message({
                      message: resp.message,
                      type: 'warning'
                    });
                }else if(resp.code==8){
                    this.$msgbox({
                        message: resp.message,
                        type: 'info'
                    });
                }
            },
            changeTeam(){
                this.teamListShow=true;
            },
            go2ImageList(idx){
                let item=this.huashuList[idx]
                localStorage.setItem("huashuData",JSON.stringify(item))
                this.$router.push({path:'/imageList',query:{id:item.id}})
            },
            huashuClick(idx){
                this.typeSelIdx=idx;
                this.labelId=this.typeList[idx].labelId;
                this.huashuListLoadend=false;
                this.huashuPage=1;
                this.huashuList=[];
                this.fetchHuashuList();
            },
            wenanCategoryClick(idx){
                this.themeCategorySelIdx=idx;
                this.wenanLabelId=this.themeCategoryList[idx].labelId;
                this.wenanListLoadend=false;
                this.wenanPage=1;
                this.wenanList=[];
                this.fetchWenanList();
            },
            itemClick(idx){
                let item=this.huashuList[idx]
                navigator.clipboard.writeText(item.allText).then(()=>{
                    // if(this.tools.isElectron){
                        this.$message({
                          message: '文本已复制',
                          type: 'success'
                        });
                        console.log("item.text==",item.allText);
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('type-text', item.allText);
                    // }
                }, function() {
                  console.log('文件复制失败！');
                });
            },
            wenanItemClick(idx){
                let item=this.wenanList[idx]
                navigator.clipboard.writeText(item.text).then(()=>{
                    // if(this.tools.isElectron){
                        this.$message({
                          message: '文本已复制',
                          type: 'success'
                        });
                        console.log("item.text==",item.text);
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('type-text', item.text);
                    // }
                }, function() {
                  console.log('文件复制失败！');
                });
            },
            async fetchData(){
                if(this.tabIndex==0){
                    this.fetchHuashuTeamList();
                }else{
                    await this.fetchDefaultWenanPackageList()
                    this.fetchWenanPackageList();
                }
            },
            //查询默认文案包列表
            async fetchDefaultWenanPackageList(){
                return new Promise(async (resolve,reject)=>{
                    let params={}
                    console.log("wenanPackageList params=",params);
                    let resp = await this.$http.defaultWenanPackageList(params)
                    if(resp.code==200){
                        this.defaultThemeList=[resp.data.object];
                    }
                    resolve();
                })
            },
            //查询文案包列表
            async fetchWenanPackageList(){
                let params={
                    page:this.themePage,
                    pageSize:this.themePageSize,
                    type:1,
                }
                console.log("wenanPackageList params=",params);
                let resp = await this.$http.wenanPackageList(params)
                console.log("wenanPackageList resp:",resp)
                if(resp.code === 200){
                    if(this.themePage==1&&resp.data.array&&!resp.data.array.length){
                        // this.themeList.splice(this.themeList.length,0,resp.data.array)
                        this.themeList=this.defaultThemeList;
                    }else if(resp.data.array&&resp.data.array.length){
                        this.themeList=resp.data.array;
                    }
                    
                    if(localStorage.getItem("lastSelThemeId")){
                        this.themeId=localStorage.getItem("lastSelThemeId");
                        this.themeList.forEach((theme,idx)=>{
                            if(this.themeId==theme.themeId){
                                this.themeSelIdx=idx;
                            }
                        })
                    }else{
                        this.themeId=this.themeList[0].themeId;
                    }
                    // else if(!this.themeList.length&&resp.data.array.length){
                    //     this.themeId=this.themeList[0].themeId;
                    // }
                    // this.themeList=resp.data.array;
                    if(this.themeList&&this.themeList.length){
                        this.fetchWenanPackageCategoryList();
                    }
                    // else{
                    //     this.$msgbox({
                    //         message: '暂无文案包，请到微脉输入法App文案广场添加',
                    //         type: 'info'
                    //     }).then(() => {
                    //         this.tabClick(0)
                    //     });
                    // }
                }else{
                    this.$message({
                      message: resp.message,
                      type: 'warning'
                    });
                }
            },
            //查询文案包分类列表
            async fetchWenanPackageCategoryList(){
                this.themeCategoryLoading=true;
                let params={
                    page:this.themeCategoryPage,
                    pageSize:this.themeCategoryPageSize,
                    themeId:this.themeId,
                }
                console.log("wenanCategoryList params=",params);
                let resp = await this.$http.wenanCategoryList(params)
                console.log("wenanCategoryList resp:",resp)
                if(resp.code === 200){
                    if(resp.data.array.length<this.themeCategoryPageSize){
                        this.themeCategoryLoadend=true;
                    }
                    if(resp.data.array.length){
                        this.themeCategoryList.splice(this.themeCategoryList.length,0,...resp.data.array);
                    }
                    if(this.themeCategoryList.length&&this.themeCategoryPage==1){
                        this.wenanLabelId=this.themeCategoryList[0].labelId;
                        this.fetchWenanList();
                    }
                    this.themeCategoryPage++;
                }else{
                    this.$message({
                      message: resp.message,
                      type: 'warning'
                    });
                }
                this.themeCategoryLoading=false;
            },
            //查询文案列表
            async fetchWenanList(){
                this.wenanloading=true;
                let params={
                    page:this.wenanPage,
                    pageSize:this.wenanPageSize,
                    themeId:this.themeId,
                    labelId:this.wenanLabelId,
                }
                console.log("wenanList params=",params);
                let resp = await this.$http.wenanList(params)
                console.log("wenanList resp:",resp)
                if(resp.code === 200){
                    if(resp.data.array.length<this.wenanPageSize){
                        this.wenanListLoadend=true;
                    }
                    if(resp.data.array.length){
                        // resp.data.array=resp.data.array.map((val)=>{
                        //     val.eleList=this.generateEleList(val.speechText);
                        //     val.imglist=val.eleList.filter((eleListItem)=>{
                        //         eleListItem.val=eleListItem.val.replace("http://","https://")
                        //          return eleListItem.type=='img'||eleListItem.type=='video'
                        //     })
                        //     val.filelist=val.eleList.filter((eleListItem)=>{
                        //         eleListItem.val=eleListItem.val.replace("http://","https://")
                        //          return eleListItem.type=='file'||eleListItem.type=='audio'
                        //     })
                        //     val.allText=this.getEleListAllText(val.eleList);
                        //     return val;
                        // })
                        this.wenanList.splice(this.wenanList.length,0,...resp.data.array);
                    }
                    if(this.wenanList.length&&this.wenanPage==1){
                        this.wenanId=this.wenanList[0].libraryId;
                    }
                    this.wenanPage++;
                }else{
                    this.$message({
                      message: resp.message,
                      type: 'warning'
                    });
                }
                this.updateCellStyle();
                this.wenanloading=false;
            },
            async fetchHuashuTeamList(){
                let params={
                }
                console.log("fetchHuashuTeamList params=",params);
                let resp = await this.$http.qryHuashuTeamList(params)
                console.log("fetchHuashuTeamList resp:",resp)
                if(resp.code === 200){
                    // if(!this.huashuTeamList.length&&!this.typeList.length&&resp.data.array.length){
                    if(localStorage.getItem("lastSelSpeechId")){
                        this.speechId=localStorage.getItem("lastSelSpeechId");
                        resp.data.array.forEach((team,idx)=>{
                            if(this.speechId==team.speechId){
                                this.teamSelIdx=idx;
                            }
                        })
                    }else if(!this.huashuTeamList.length&&resp.data.array.length){
                        this.speechId=resp.data.array[0].speechId;
                    }
                    this.huashuTeamList=resp.data.array;
                    if(resp.data.array&&resp.data.array.length){
                        this.fetchHuashuTypeList();
                    }
                }else{
                    this.$message({
                      message: resp.message,
                      type: 'warning'
                    });
                }
            },
            async fetchHuashuTypeList(){
                this.hushuTypeLoading=true;
                let params={
                    page:this.typePage,
                    pageSize:this.typePageSize,
                    speechId:this.speechId,
                }
                console.log("qryHuashuTypeList params=",params);
                let resp = await this.$http.qryHuashuTypeList(params)
                console.log("qryHuashuTypeList resp:",resp)
                if(resp.code === 200){
                    if(resp.data.array.length<this.typePageSize){
                        this.typeListLoadend=true;
                    }
                    if(resp.data.array.length){
                        this.typeList.splice(this.typeList.length,0,...resp.data.array);
                    }
                    if(this.typeList.length&&this.typePage==1){
                        this.labelId=this.typeList[0].labelId;
                        this.fetchHuashuList();
                    }
                    this.typePage++;
                }else{
                    this.$message({
                      message: resp.message,
                      type: 'warning'
                    });
                }
                this.hushuTypeLoading=false;
            },
            async fetchHuashuList(){
                this.loading=true;
                let params={
                    page:this.huashuPage,
                    pageSize:this.huashuPageSize,
                    speechId:this.speechId,
                    labelId:this.labelId,
                }
                console.log("qryHuashuList params=",params);
                let resp = await this.$http.qryHuashuList(params)
                console.log("qryHuashuList resp:",resp)
                if(resp.code === 200){
                    if(resp.data.array.length<this.huashuPageSize){
                        this.huashuListLoadend=true;
                    }
                    if(resp.data.array.length){
                        resp.data.array=resp.data.array.map((val)=>{
                            val.eleList=this.generateEleList(val.speechText);
                            val.imglist=val.eleList.filter((eleListItem)=>{
                                eleListItem.val=eleListItem.val.replace("http://","https://")
                                 return eleListItem.type=='img'||eleListItem.type=='video'
                            })
                            val.filelist=val.eleList.filter((eleListItem)=>{
                                eleListItem.val=eleListItem.val.replace("http://","https://")
                                 return eleListItem.type=='file'||eleListItem.type=='audio'
                            })
                            val.allText=this.getEleListAllText(val.eleList);
                            return val;
                        })
                        this.huashuList.splice(this.huashuList.length,0,...resp.data.array);
                    }
                    if(this.huashuList.length&&this.huashuPage==1){
                        this.huashuDetailId=this.huashuList[0].id;
                    }
                    this.huashuPage++;
                }else{
                    this.$message({
                      message: resp.message,
                      type: 'warning'
                    });
                }
                this.updateCellStyle();
                this.loading=false;
            },
            updateCellStyle(){
                setTimeout(()=>{
                    let list=[]
                    if(this.tabIndex==0){
                        list=JSON.parse(JSON.stringify(this.huashuList))
                    }else{
                        list=JSON.parse(JSON.stringify(this.wenanList))
                    }
                    list.forEach((item)=>{
                        let id=this.tabIndex==0?item.id:item.libraryId;
                        if(this.$refs[id]){
                            let ele=this.$refs[id][0];
                            let showEle=this.$refs['show'+id][0];
                            if(showEle.clientHeight>59&&ele.clientHeight>showEle.clientHeight){
                                item.showBtn='zhankai';
                            }
                            console.log("ele:",ele);
                        }
                    })
                    if(this.tabIndex==0){
                        this.huashuList=list;
                    }else{
                        this.wenanList=list;
                    }
                },1)
            },
            replaceAll(string, search, replace) { 
              return string.split(search).join(replace); 
            },
            generateEleList(speechText){
              let eleList=[]
              let _this=this;
              // this.huashuList.forEach((huashu)=>{
                let text=speechText;
                text=this.replaceAll(text,"<分段>","");

                // const urlRegex = /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/gi;
                const urlRegex = /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
                const urls = [];
                let match;
                let lastPart=text;

                while ((match = urlRegex.exec(text)) !== null) {
                  let url = match[0];
                  const fileExtension = this.getFileExtension(url);

                  // 只添加具有正确文件后缀的URL
                  if (fileExtension === 'png'||fileExtension === 'jpg'||fileExtension === 'jpeg'||fileExtension === 'pdf'||fileExtension === 'doc'||fileExtension === 'docx'||fileExtension === 'dotm'||fileExtension === 'dotx'||fileExtension === 'dotm'||fileExtension === 'txt'||fileExtension === 'xlsx'||fileExtension === 'xls'||fileExtension === 'mp4'||fileExtension === 'mov'||fileExtension === 'mp3'||fileExtension === 'm4a'||fileExtension === 'aac'||fileExtension === 'caf'||fileExtension === 'ppt'||fileExtension === 'pptx') {
                    let tmp=lastPart.split(url);
                    // console.log("tmp==",tmp[0]);
                    eleList.push({
                      type:"text",
                      val:tmp[0],
                    })
                    if(fileExtension==='jpg'||fileExtension==='png'||fileExtension==='jpeg'){
                      eleList.push({
                        type:"img",
                        val:url,
                      })
                      // this.imgUrlList.push(url)
                    }else if(fileExtension==='mp4'){
                      eleList.push({
                        type:"video",
                        val:url,
                      })
                    }else if(fileExtension==='mp3'||fileExtension==='m4a'){
                      let eleIdx=eleList.length;
                      let tmpUrl = new URL(url);
                        let fileName = tmpUrl.pathname.split('/').pop();
                      let audio=new Audio();
                      audio.src=url;
                      audio.id="audio"+eleIdx;
                      let id=new Date().getTime();
                      eleList.push({
                        type:"audio",
                        val:url,
                        fileName:fileName,
                        fileIcon:this.getFileIcon(fileName),
                        id:id
                      })
                    //   audio.muted = true;
                    //   audio.play().then(()=>{audio.pause()})
                    //   audio.muted = false;
                    //   audio.addEventListener("loadedmetadata", ()=>{
                    //     console.log("audio duration==",audio.duration);
                    //     this.eleList.forEach((ele,idx)=>{
                    //       if(ele.id==id){
                    //         this.eleList.splice(idx,1,{
                    //           type:"audio",
                    //           val:url,
                    //           fileName:fileName,
                    //           fileIcon:this.getFileIcon(fileName),
                    //           duration:audio.duration*1000,
                    //         });
                    //       }
                    //     })
                    //   });
                    //   this.audioList.push(audio)
                    }else{
                      let tmpUrl = new URL(url);
                      const fileName = tmpUrl.pathname.split('/').pop();
                      eleList.push({
                        type:"file",
                        val:url,
                        fileName:fileName,
                        fileIcon:this.getFileIcon(fileName)
                      })
                    }
                    // lastPart=tmp[1]
                    let str=""
                    tmp.forEach((tmpItem,idx)=>{
                      if(idx){
                        str+=tmpItem
                      }
                    })
                    lastPart=str;
                  }
                }
                eleList.push({
                  type:"text",
                  val:lastPart,
                })
                // console.log(eleList);
              // })
              // this.eleList=eleList;
                return eleList
            },
            //获取元素数组的所有文本集合
            getEleListAllText(eleList){
                let text="";
                eleList.forEach((ele)=>{
                    if(ele.type=="text"){
                        text+=ele.val;
                    }
                })
                return text;
            },
            // 提取文件后缀的辅助函数
            getFileExtension(url) {
              const path = url.split('/');
              const fileName = path[path.length - 1];
              const parts = fileName.split('.');
              
              if (parts.length > 1) {
                return parts.pop();
              }
              
              return '';
            },
            getVideoDuration(url){
              let video=document.createElement('video');
              video.src=url;
              video.load();
              video.onload=()=>{
                console.log("video==",video);
              }
            },
            getFileIcon(fileName){
              let icon=""
              if(fileName.includes(".doc")){
                icon="https://imagessl.edujia.com/A-1ed71af7_20230602143256.png"
              }else if(fileName.includes(".txt")){
                icon="https://imagessl.edujia.com/A-1ed71af7_20230602143245.png"
              }else if(fileName.includes(".xls")){
                icon="https://imagessl.edujia.com/A-1ed71af7_20230602143214.png"
              }else if(fileName.includes(".mp3")||fileName.includes(".m4a")){
                icon="https://imagessl.edujia.com/A-1ed71af7_20230529114041.png"
              }else if(fileName.includes(".pdf")){
                icon="https://imagessl.edujia.com/A-1ed71af7_20230529114100.png"
              }else if(fileName.includes(".ppt")||fileName.includes(".pptx")){
                icon="https://imagessl.edujia.com/A-1ed71af7_20230608114321.png"
              }else{
                icon="https://imagessl.edujia.com/A-1ed71af7_20230601152642.png"
              }
              return icon;
            },
        },
        created(){
            window.addEventListener('resize',()=>{
                this.pageWidth=window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                this.pageHeight=window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            })
            this.faceIcon=localStorage.getItem("edujia:group:web:faceIcon")
            if(localStorage.getItem("edujia:group:web:token")){
                this.$store.commit('modifyToken',localStorage.getItem("edujia:group:web:token"))
            }
            if(localStorage.getItem('typeListWidth')){
                this.typeListWidth=localStorage.getItem('typeListWidth')
            }
        },
        mounted(){
        },
        activated(){
            if(localStorage.getItem("needReresh")){
                this.typePage=1;
                this.typeListLoadend=false;
                this.typeList=[];
                localStorage.removeItem("needReresh");
            }
            this.fetchData();
            if(localStorage.getItem("updateHuashuItem")){
                let huashuItem=JSON.parse(localStorage.getItem("updateHuashuItem"))
                huashuItem.eleList=this.generateEleList(huashuItem.speechText);
                huashuItem.imglist=huashuItem.eleList.filter((eleListItem)=>{
                    eleListItem.val=eleListItem.val.replace("http://","https://")
                        return eleListItem.type=='img'||eleListItem.type=='video'
                })
                huashuItem.filelist=huashuItem.eleList.filter((eleListItem)=>{
                    eleListItem.val=eleListItem.val.replace("http://","https://")
                        return eleListItem.type=='file'||eleListItem.type=='audio'
                })
                huashuItem.allText=this.getEleListAllText(huashuItem.eleList);
                let resultIdx=-1;
                this.huashuList.forEach((val,idx)=>{
                    if(huashuItem.id==val.id){
                        resultIdx=idx;
                    }
                })
                if(resultIdx!=-1){
                    this.huashuList.splice(resultIdx,1,huashuItem)
                }else if(huashuItem.isFront==1){
                    this.huashuList.splice(0,0,huashuItem)
                }else{
                    this.huashuList.splice(this.huashuList.length,0,huashuItem)
                }
                // if(this.huashuListLoadend){
                //     this.huashuList.splice(this.huashuList.length,0,huashuItem)
                // }
                localStorage.removeItem("updateHuashuItem");
                this.updateCellStyle();
            }
        },
    }
</script>

<style scoped>
.top{
    padding-bottom: 8px;
/*    height: 32px;*/
    height: 74px;
    padding-top: 40px;
    box-shadow: 0 2px 4px 0 #e5e5e58a;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    min-width: 200px;
}

.topSub{
    display: flex;
    justify-content: space-between;
    min-width: 380px;
}

.topLLP{
    margin-left: 16px;
    display: flex;
    align-items: center;
    min-width: 120px;
}

.topLLItem{
    
}

.topLLItemSel{
    color: #FB5D5C;
    font-size: 16px;
}

.topLLItemLine{
    width: 1px;
    height: 16px;
    background-color: #BDBDBD;
    margin-left: 8px;
    margin-right: 8px;
}

.topLLItem span{
    font-size: 14px;
    font-weight: 500;
}

.topLLItem div{
    width: 24px;
    height: 2px;
    border-radius: 2px;
    margin-top: 2px;
    background-color: #FB5D5C;
    margin: auto;
}

.topL{
    display: flex;
    align-items: center;
}

.topLL{
    width: 20px;
    height: 20px;
    margin-left: 14px;
}

.topLR{
    font-size: 14px;
    font-weight: 500;
    color: #3c3c3c;
    margin-left: 8px;
    max-width: 150px;
    height: 32px;
    line-height: 32px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.topRP{
    display: flex;
    align-items: center;
    min-width: 170px;
}

.topRR2{
    display: flex;
}

.topR{
    display: flex;
    align-items: center;
/*    margin-right: 16px;*/
}

.topRL{
    width: 14px;
    height: 15px;
    margin-left: 14px;
}

.topRR{
    margin-left: 8px;
    color: #4A90E2;
    font-size: 14px;
/*    padding-right: 20px;*/
/*    border-right: 1px solid #BDBDBD;*/
}

.content{
    display: flex;
/*    padding-top: 83px;*/
    padding-top: 125px;
}

.typeList{
/*    width: 144px;*/
    min-width: 50px;
    max-width: 200px;
    background-color: #F5F6F6;
    overflow: scroll;
}

::-webkit-scrollbar{
    display: none;
}

.typeListItem{
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #F5F6F6;
    font-size: 14px;
    color: #3C3C3C;
    padding-left: 14px;
}

.typeListItem div{
/*    width: 112px;*/
    width: 90%;
    text-overflow: ellipsis;
    overflow: hidden;    
    white-space: nowrap;
}

.typeListItemSel{
    background-color: #fff;
    color: #FB5D5C;
    font-weight: 500;
}

.huashuList{
/*    width: 77%;*/
    overflow: scroll;
    flex:1;
}

.huashuListItem{
    padding: 4px 8px 4px 0px;
    border-bottom: 1px solid #E5E5E5;
    margin-left: 8px;
    position: relative;
}

.huashuListItemTop{
    display: flex;
    align-items: center;
}

.huashuListItemTopL{
    width: 20px;
    height: 20px;
}

.huashuListItemTopM{
    margin-left: 4px;
    margin-right: 8px;
    font-size: 14px;
    line-height: 25px;
    font-weight: 500;
    color: #3C3C3C;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 90%;
    white-space: nowrap;
}

.huashuListItemTopMBig{
    font-size: 16px;
    font-weight: bold;
    margin-left: 0;
}

.huashuListItemTopR{
    width: 24px;
    height: 24px;
}

.actionBtn{
    color: #4A90E2;
    font-size: 14px;
}

.huashuListItemDetailP{
    border-bottom: 1px solid #E5E5E5;
}

.huashuListItemDetail{
    margin-top: 4px;
    font-size: 14px;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 20px;
}

.huashuListItemDetailShowmore{
    margin-top: 4px;
    font-size: 14px;
    white-space: pre-wrap;
}

.huashuListItemDetailNoHide{
    margin-top: 4px;
    font-size: 14px;
    white-space: pre-wrap;
    position: absolute;
    /*left: -10000px;
    bottom: -10000px;*/
    left: 0;
    top: 0;
    opacity: 0;
    line-height: 20px;
    pointer-events: none;
}

.teamListCover{
    position: absolute;
    top: 38px;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 4px 8px 0 #e5e5e580;
    z-index: 999;
}

.teamListP{
    display: flex;
    justify-content: center;
}

.teamList{
    width: 89.74%;
    display: flex;
    flex-wrap: wrap;
}

.teamListItem{
    width: 33%;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #E5E5E5;
    background-color: #F5F6F6;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3C3C3C;
    font-size: 14px;
    flex-basis: calc(33.33% - 20px); /* 让每个子元素等分，这里假设有3个子元素，减去10px的间隔 */
    margin: 10px; /* 添加间隔 */
    box-sizing: border-box;
    position: relative;
}

.teamListItem img{
    position: absolute;
    left: 0;
    top: 0;
    width: 16px;
    height: 16px;
}

.teamListItem div{
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 80%;
    overflow: hidden;
    text-align: center;
}

.teamListItemSel{
    border-color: #FB5D5C;
    background-color: #FFF6F6;
    color: #FB5D5C;
}

.shouqiBtnP{
    display: flex;
    justify-content: center;
}

.shouqiBtn{
    color: #4A90E2;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin: auto;
}

.shouqiBtn img{
    width: 14px;
    height: 8px;
    margin-left: 4px;
}

.huashuListItemDetailNoTitle{
/*    padding-left: 23px;*/
    position: relative;
}

/*.huashuListItemDetailNoTitle::before{
    content: "";
    float: left;
    background-image: url("https://imagessl.edujia.com/A-1ed71af7_20230804141713.png");
    background-repeat: no-repeat;
    background-size: 23px 14px;
    width: 23px;
    height: 14px;
}
*/
.imgTmp{
    width: 24px;
    height: 24px;
    position: absolute;
    left: 0;
    top: 0;
}

.header-main-top{
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 14px;
    object-fit: cover;
}

.bottomBar{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    min-width: 510px;
    z-index: 999999;
    background-color: #fff;
}

.addTypeBtn{
    width: 143px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 16px;
}

.addTypeBtn img{
    width: 14px;
    height: 14px;
    margin-right: 4px;
}

.addTypeBtn div{
    width: 109px;
    font-size: 14px;
    color: #4A90E2;
    border-right: 1px solid #E5E5E5;
    line-height: 16px;
}

.addHuashuBtn{
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 16px;
}

.addHuashuBtn img{
    width: 14px;
    height: 14px;
    margin-right: 4px;
}

.addHuashuBtn div{
    font-size: 14px;
    color: #4A90E2;
    line-height: 16px;
}

.psLbl{
    position: absolute;
    right: 16px;
    top: 12px;
    font-size: 14px;
    color: #3C3C3C;
    line-height: 20px;
}

.sizeBtn{
    width: 6px;
    border-radius: 7px;
    height: 50px;
/*    background-color: red;*/
    display: flex;
    justify-content: space-evenly;
    pointer-events: none;
}

.sizeBtn div{
    width: 1px;
    height: 50px;
    background-color: lightgray;
}

.custom-resizer{
    width: 100%;
}

.layout-v > .multipane-resizer {
    width: 14px;
    height: 100%;
    margin-left: -10px;
    left: 5px;
    cursor: col-resize;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10px;
    background-color: #fff;
/*    border-left: 1px solid #eee;
    border-right: 1px solid #eee;*/
}

.searchArea{
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 150px;
}

.searchAreaBar{
    width: 79.5%;
    height: 32px;
    background-color: #F5F6F6;
    display: flex;
    align-items: center;
    margin-left: 16px;
    margin-right: 8px;
    border-radius: 4px;
}

.searchAreaBar img{
    width: 14px;
    height: 14px;
    margin-left: 12px;
    margin-right: 8px;
}

.searchAreaBar input{
    width: 90%;
    height: 18px;
    border: none;
    font-size: 13px;
    background-color: transparent;
}

.searchAreaBtn{
    width: 88px;
    height: 32px;
    background-color: #FB5D5C;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 13px;
    border-radius: 4px;
    margin-right: 16px;
}

.searchAreaCancelBtn{
    border: 1px solid #FB5D5C;
    background-color: #FFF6F6;
    color: #FB5D5C;
}

.importHuashuBtn{
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 16px;
    color: #3C3C3C;
    font-size: 14px;
}

.importHuashuBtn img{
    width: 14px;
    height: 14px;
    margin-right: 4px;
    margin-left: 16px;
}
</style>